import axios, { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { handleError } from '../helpers';
export const serverSideAxiosInstance: AxiosInstance = axios.create({});
const attachServerSideInterceptors = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.request.use(
    (request): InternalAxiosRequestConfig => {
      if (request?.headers) {
        // attach some static request headers for each request
      }
      return request;
    },
    (error: AxiosError): Promise<AxiosError> => {
      if (error.response) {
        handleError(error.response.status);
        return Promise.reject(error.response);
      } else {
        return Promise.reject(error);
      }
    },
  );
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse): AxiosResponse => {
      if (response?.headers) {
        // attach some static response headers for each response
      }
      return response;
    },
    (error: AxiosError): Promise<AxiosError> => {
      if (error.response) {
        handleError(error.response.status);
        return Promise.reject(error.response);
      } else {
        return Promise.reject(error);
      }
    },
  );
};

attachServerSideInterceptors(serverSideAxiosInstance);
